import { Box, Button, Card, SxProps, Typography, useMediaQuery } from "@mui/material";
import { ArrowNewLeft } from "icons";
import { ArrowNewRight } from "icons/ArrowNewRight";
import { useState } from "react";
import SwipeableViews from "react-swipeable-views";
import { ImageSlider } from "./components/ImageSlider";
import { CustomTheme } from "helpers/Theme";
import { ITourDayDetail } from "types/Tour";

type TourDayDetailProps = {
  image: ITourDayDetail[];
  title: string;
  subtitle: string;
  description: string;
};

const getStyles = () => {
  const container: SxProps<CustomTheme> = {
    display: "flex",
    alignItems: "center",
    gap: { xs: 3, sm: 0 },
    flexDirection: { xs: "column", sm: "row" },
    marginInline: 3
  };
  const card: SxProps<CustomTheme> = {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    justifyContent: "center",
    alignItems: "center",
    overflow: "visible"
  };
  const contentButton: SxProps<CustomTheme> = {
    display: "flex",
    width: 160,
    justifyContent: "space-between",
    position: "absolute",
    bottom: { xs: -480, sm: -80 }
  };
  const arrowButton: SxProps<CustomTheme> = {
    minWidth: 0,
    padding: 0.5,
    boxShadow: "0px 7.18px 14.36px 3.59px #0000001A",
    borderRadius: 71
  };
  const contentDetail: SxProps<CustomTheme> = {
    display: "flex",
    flexDirection: "column",
    width: { sm: 595, xs: "100%" },
    height: { sm: 278, xs: 395 },
    borderRadius: 3,
    boxShadow: "0px 0px 20px 0px #0000001A",
    backgroundColor: "#FFFFFFF2",
    position: "relative",
    right: { sm: 15, xs: 0 }
  };
  return { container, card, arrowButton, contentButton, contentDetail };
};
export const TourDayDetail = ({ image, title, subtitle, description }: TourDayDetailProps) => {
  const styles = getStyles();
  const xs = useMediaQuery("(max-width: 750px)");
  const [index, setIndex] = useState(0);
  const OnNext = () => {
    setIndex(preview => preview + 1);
  };
  const OnBack = () => {
    setIndex(preview => preview - 1);
  };
  return (
    <Box sx={styles.container}>
      <Card sx={styles.card} elevation={0}>
        <SwipeableViews
          style={{
            maxWidth: xs ? "100%" : 595,
            borderRadius: 20
          }}
          index={index}
          onChangeIndex={setIndex}>
          {image.map(v => (
            <ImageSlider
              key={v.id}
              label={v.label}
              src={v.url}
              alt={v.label}
              labelColor="common.white"
            />
          ))}
        </SwipeableViews>
        <Box sx={styles.contentButton}>
          <Button sx={styles.arrowButton} onClick={OnBack} disabled={index === 0}>
            <ArrowNewLeft />
          </Button>
          <Button sx={styles.arrowButton} onClick={OnNext} disabled={index === 2}>
            <ArrowNewRight />
          </Button>
        </Box>
      </Card>
      <Box sx={styles.contentDetail}>
        <Box display="flex" flexDirection="column" gap={5} p={5}>
          <Box display="flex" flexDirection="column" gap={3}>
            <Typography variant="h3" color="common.black">
              {title}
            </Typography>
            <Typography
              variant="subtitle2"
              color="common.black"
              pb={3}
              borderBottom="solid 1px #CDCDCD">
              {subtitle}
            </Typography>
          </Box>
          <Typography
            variant="body1"
            whiteSpace="pre-line"
            color="#070707CC"
            overflow="auto"
            textOverflow="ellipsis"
            maxHeight={{ md: 300, xs: "auto" }}>
            {description}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
